<ng-container *ifSize="'XL'">
    <button class="button-4 button-size-1 p-l-2 p-r-2"
            (click)="openPreview()"
            [class.pe-none]="status.busy">
        <span>{{'Quick Buy' | translate}}</span>
    </button>
</ng-container>
<div class="pos-relative _wrapper right"
     *ifSize="'SM'">
    <!-- Init animation
     @if (showAnimation) {
    <span [@buttonHide]="state"
      class=" no-wrap overflow-hidden col-12 p2 _text pe-none"
      ><span class="p-l-1">{{'Quick Buy' | translate}}</span></span>
    } -->
    <button class="_icon bg-col-w"
            (click)="openPreview()"
            [class.pe-none]="status.busy">
        <i class="flex col-12 p-a-1"
           [ngClass]="status.busy ? 'icon-loading' : 'icon-basket-add'"
           aria-hidden="true"></i>
    </button>
</div>
